import ArticleThumbnail from "./ArticleThumbnail";

export default ArticleThumbnail;